import {signInWithEmailAndPassword, UserCredential, User} from "firebase/auth";
import {auth} from "./firebaseInit";

export async function getToken(email: string, password: string): Promise<string> {
    const logRes: UserCredential = await signInWithEmailAndPassword(auth, email, password);
    const user: User = logRes.user;
    return await user.getIdToken();
}